{
  "identity": {
    "title": "Identität"
  },
  "status": {
    "title": "Status"
  },
  "lastUpdate": {
    "title": "Zuletzt aktualisiert"
  },
  "profile": {
    "title": "Profil"
  },
  "group": {
    "title": "Gruppe"
  },
  "state": {
    "title": "Status"
  },
  "name": {
    "title": "Name"
  },
  "operations": {
    "title": "Betrieb"
  },
  "connectionParameters": {
    "title": "Verbindungseinstellungen"
  },
  "specificParameters": {
    "title": "Spezifische Parameter"
  },
  "roles": {
    "title": "Rollen"
  }
}
